import dynamic from 'next/dynamic'

export const DynamicShoppingPersonaSelectorModal = dynamic(
  () => import('.').then((mod) => mod.ShoppingPersonaSelectorModal),
  { ssr: false },
)
